<template>
  <div class="jy-badge">
    <div v-if="isSup">
      <slot></slot>
      <transition name="jy-zoom-in-center">
        <sup
          v-show="!hidden && ( content || isDot )"
          v-text="content"
          class="jy-badge__content"
          :class="{ 'is-fixed': $slots.default, 'is-dot': isDot }">
        </sup>
      </transition>
    </div>
    <a v-else-if="isA" class="badge" :class="badgeClass" :href="href ? href : 'javascript:;'" :style="badgeStyle">
      <slot></slot>
    </a>
    <span v-else class="badge" :class="badgeClass" :style="badgeStyle">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'JyBadge',
  props: {
    type: {
      type: String,
      default: 'secondary'
    },
    value: {},
    max: Number,
    isDot: Boolean,
    hidden: Boolean,
    isSup: Boolean,
    isA: Boolean,
    isPill: Boolean,
    href: String
    /* xknaan add */
    ,
    width: String
  },
  computed: {
    badgeClass() {
      let _class = 'badge-'+ (this.type || 'secondary');
      if (this.isPill) _class += ' badge-pill';
      return _class;
    },
    badgeStyle() {
      return this.width ? {width: this.width} : {};
    },
    content() {
      if (this.isDot) return;

      const value = this.value;
      const max = this.max;

      if (typeof value === 'number' && typeof max === 'number') {
        return max < value ? `${max}+` : value;
      }

      return value;
    }
  }
};
</script>
